/**
 * reCAPTCHA v3 (docs/architecture.md §7.1): невидимая, токен берётся перед отправкой формы.
 * Ключ сайта приходит с сервера (`/auth/options`); `null` — капча выключена (локально),
 * и в API уходит пустая строка.
 */

interface Grecaptcha {
  ready(callback: () => void): void;
  execute(siteKey: string, options: { action: string }): Promise<string>;
}

declare global {
  interface Window {
    grecaptcha?: Grecaptcha;
  }
}

let loading: Promise<Grecaptcha> | undefined;

function load(siteKey: string): Promise<Grecaptcha> {
  loading ??= new Promise<Grecaptcha>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
    script.async = true;
    script.onload = () => {
      const grecaptcha = window.grecaptcha;
      if (grecaptcha === undefined) reject(new Error('reCAPTCHA failed to initialize'));
      else grecaptcha.ready(() => resolve(grecaptcha));
    };
    script.onerror = () => {
      loading = undefined;
      reject(new Error('reCAPTCHA failed to load'));
    };
    document.head.append(script);
  });
  return loading;
}

export type CaptchaAction = 'register' | 'login' | 'password_reset' | 'resend_verification';

export async function captchaToken(siteKey: string | null, action: CaptchaAction): Promise<string> {
  if (siteKey === null) return '';
  const grecaptcha = await load(siteKey);
  return grecaptcha.execute(siteKey, { action });
}
